import CustomerAddressModel from './customer-address-model';
import CustomerDocumentModel from './customer-document-model';

export default class CustomerPartnerShareholderModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.name = obj.name;
    this.cpfCnpj = obj.cpfCnpj;
    this.share = obj.share;
    this.ownershipPercentage = obj.ownershipPercentage || obj.share;
    this.title = obj.title;
    this.isLegalPerson = !!obj.isLegalPerson;
    this.email = obj.email;
    this.cellphone = obj.cellphone;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
    this.linkedCustomerId = obj.linkedCustomerId;
    this.wasLinked = obj.wasLinked;
    this.divergentDate = obj.divergentDate ?? null;
    this.isBrazilian = !!obj.isBrazilian;
    this.taxType = obj.taxType || null;
    this.foreignTaxId = obj.foreignTaxId || null;
    this.averageMonthlyIncome = (obj.averageMonthlyIncome && Number(obj.averageMonthlyIncome)) || 0;
    this.birthDate = obj.birthDate ?? null;
    this.additional = obj.additional && typeof obj.additional === 'object' ? { ...obj.additional } : {};
    this.addresses = Array.isArray(obj.addresses)
      ? obj.addresses.map((a) => new CustomerAddressModel(a))
      : [];
    this.documents = Array.isArray(obj.documents)
      ? obj.documents.map((d) => new CustomerDocumentModel(d))
      : [];
  }
}
